import parse, { HTMLReactParserOptions } from 'html-react-parser';
import Latex from 'react-latex-next';
import { hasLatexExpression, shouldSkipLatexParentTag } from './latex';
import { isMathMlTag } from './mathml';
import 'katex/dist/katex.min.css';

type ReplaceHandler = NonNullable<HTMLReactParserOptions['replace']>;

const replaceMathMlAndLatex: ReplaceHandler = (domNode, _index) => {
  if (domNode.type === 'text') {
    const text = domNode.data;

    const parentName =
      domNode.parent?.type === 'tag' ? domNode.parent.name : undefined;

    if (
      text &&
      hasLatexExpression(text) &&
      !shouldSkipLatexParentTag(parentName)
    ) {
      return <Latex>{text}</Latex>;
    }

    return undefined;
  }

  if (domNode.type === 'tag' && isMathMlTag(domNode.name)) {
    return undefined;
  }

  return undefined;
};

export const withMathLatexParserOptions = (
  parserOptions?: HTMLReactParserOptions
): HTMLReactParserOptions => {
  const customReplace = parserOptions?.replace;

  return {
    ...parserOptions,
    replace: (domNode, index) => {
      const customResult = customReplace?.(domNode, index);
      if (customResult !== undefined) {
        return customResult;
      }

      return replaceMathMlAndLatex(domNode, index);
    },
  };
};

export const parseHtmlWithMathLatex = (
  html: string,
  parserOptions?: HTMLReactParserOptions
) => {
  return parse(html, withMathLatexParserOptions(parserOptions));
};
